let currentPricePackage = null;

class PricePackage {
    getPriceFunc
    timeoutId
    getPricePromiseResolvers = {}

    constructor(getPriceFunc) {
        this.getPriceFunc = getPriceFunc;
    }

    async getPrice(offer) {
        return new Promise((resolve) => {
            this.getPricePromiseResolvers[offer.id] = {
                offer: offer,
                resolver: resolve,
            };

            clearTimeout(this.timeoutId);

            this.timeoutId = setTimeout(async () => {
                currentPricePackage = null;
                try {
                    const result = await this.getPriceFunc(
                        Object.values(this.getPricePromiseResolvers)
                            .map((data) => data.offer));

                    result.forEach((resultItem) => {
                        const { resolver } = this.getPricePromiseResolvers[resultItem.id];
                        if (resolver) {
                            resolver(resultItem);
                        }
                    });
                } catch (error) {
                    console.error('Failed to fetch getPrice', error);
                }
            });
        });
    }
}

export default async function useOfferGetPriceController(offer, getPriceFunc) {
    if (!currentPricePackage) {
        currentPricePackage = new PricePackage(getPriceFunc);
    }

    return currentPricePackage.getPrice(offer);
}
